import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import Spinner from 'react-spinner';

import { resetUserPassword, undeleteUser, updateUser, payeeUser, adminUser } from '../../actions/userActions';

class EditUser extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: this.props.editedUser.name,
            email: this.props.editedUser.email,
            enabled: this.props.editedUser.enabled,
            deleted: this.props.editedUser.deleted,
            paying: this.props.editedUser.paying,
            isAdmin: this.isAdmin()
        }

        this.message = '';
        this.messageClass = 'text-primary';
    }

    isAdmin() {
        return !!this.props.admins.filter(admin => {
            return admin.id === parseInt(this.props.match.params.id, 10);
        }).length;
    }

    renderMessage() {
        const { activateError, resetError, undeleteError, updateError, adminError } = this.props;

        if (activateError || resetError || undeleteError || updateError || adminError) {
            this.message = this.props.intl.formatMessage({id: 'edit.user.messages.error'});
            this.messageClass = 'text-danger';
        }

        return <p className={this.messageClass}>{this.message}</p>;
    }

    onNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    }

    onEmailChange = (e) => {
        this.setState({
            email: e.target.value
        });
    }

    onEditSubmit = (e) => {
        e.preventDefault();
        const { id } = this.props.match.params;
        const { name, email } = this.state;
        const userData = {
            name,
            email
        }

        this.props.updateUser(id, userData).then(this.message = this.props.intl.formatMessage({id: 'edit.user.messages.success.update'}));
    }

    onPayeeUserClick = () => {
        this.props.payeeUser(this.props.match.params.id).then(() => {
            if (!this.state.paying) {
                this.message = this.props.intl.formatMessage({id: 'edit.user.messages.success.payeeOn'});
            }
            if (this.state.paying) {
                this.message = this.props.intl.formatMessage({id: 'edit.user.messages.success.payeeOff'});
            }

            this.setState({
                paying: !this.state.paying
            });
        });
    }

    onActivateUserClick = () => {
        this.props.activateUser(this.props.match.params.id).then(() => {
            if (!this.state.enabled) {
                this.message = this.props.intl.formatMessage({id: 'edit.user.messages.success.activate'});
            }
            if (this.state.enabled) {
                this.message = this.props.intl.formatMessage({id: 'edit.user.messages.success.deactivate'});
            }

            this.setState({
                enabled: !this.state.enabled
            });
        });
    }

    onAdminUserClick = () => {
        this.props.adminUser(this.props.match.params.id).then(() => {
            if (!this.state.isAdmin) {
                this.message = this.props.intl.formatMessage({id: 'edit.user.messages.success.adminOn'});
            }
            if (this.state.isAdmin) {
                this.message = this.props.intl.formatMessage({id: 'edit.user.messages.success.adminOff'});
            }

            this.setState({
                isAdmin: !this.state.isAdmin
            });
        });
    }

    renderSpinner() {
        const { activateLoading, updateLoading, resetLoading, undeleteLoading } = this.props;

        if (activateLoading || updateLoading || resetLoading || undeleteLoading) {
            return <Spinner />
        }
    }

    render() {
        const userId = this.props.match.params.id;
        const { intl } = this.props;

        return (
            <div className="animated fadeIn">
                {this.renderSpinner()}
                <table className="table table-hover table-outline mb-0 hidden-sm-down table-responsive">
                    <thead className="thead-default">
                        <tr>
                            <th>
                                <FormattedMessage id="edit.user.table.headers.user"/>
                            </th>
                            <th className="text-center edit-user__table-header">
                                <FormattedMessage id="edit.user.table.headers.payee"/>
                            </th>
                            <th className="text-center edit-user__table-header">
                                <FormattedMessage id="edit.user.table.headers.reset"/>
                            </th>
                            <th className="text-center edit-user__table-header">
                                <FormattedMessage id="edit.user.table.headers.cancel"/>
                            </th>
                            <th className="text-center edit-user__table-header">
                                <FormattedMessage id="edit.user.table.headers.admin"/>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <form onSubmit={this.onEditSubmit} className="edit-user__form">
                                    <div className="row justify-content-md-left">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    value={this.state.name || ''}
                                                    onChange={this.onNameChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    value={this.state.email}
                                                    onChange={this.onEmailChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <button type="submit" className="btn btn-success">
                                                <FormattedMessage id="edit.user.buttons.save"/>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </td>
                            <td className="text-right">
                                <button
                                    type="button"
                                    className="btn btn-success edit-user__btn"
                                    onClick={this.onPayeeUserClick}
                                    disabled={!this.state.enabled}
                                >
                                    {!this.state.paying ? <FormattedMessage id="edit.user.buttons.payee.on"/> : <FormattedMessage id="edit.user.buttons.payee.off"/>}
                                </button>
                            </td>
                            <td className="text-right">
                                <button
                                    type="button"
                                    className="btn btn-secondary edit-user__btn"
                                    onClick={() => {this.props.resetUserPassword(userId).then(this.message = intl.formatMessage({id: 'edit.user.messages.success.reset'}))}}
                                >
                                    <FormattedMessage id="edit.user.buttons.reset"/>
                                </button>
                            </td>
                            <td className="text-right">
                                <button
                                    type="button"
                                    className="btn btn-secondary edit-user__btn"
                                    data-id={userId}
                                    onClick={() => {this.props.undeleteUser(userId).then(this.message = intl.formatMessage({id: 'edit.user.messages.success.undelete'}))}}
                                    disabled={!this.state.deleted || this.props.undeleteSuccess}
                                >
                                    <FormattedMessage id="edit.user.buttons.cancel"/>
                                </button>
                            </td>
                            <td className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-secondary edit-user__btn"
                                    data-id={userId}
                                    onClick={this.onAdminUserClick}
                                    disabled={!this.state.enabled}
                                >
                                    {!this.state.isAdmin ? <FormattedMessage id="edit.user.buttons.adminOn"/> : <FormattedMessage id="edit.user.buttons.adminOff"/>}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br/>
                {this.renderMessage()}
                <br/>
                <button
                    className="btn btn-secondary"
                    onClick={() => {this.props.history.goBack()}}
                >
                    <FormattedMessage id="edit.user.buttons.back"/>
                </button>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        admins: state.user.admins.data,
        editedUser: state.user.edit,
        updateSuccess: state.user.update.success,
        updateLoading: state.user.update.loading,
        updateError: state.user.update.error,
        resetSuccess: state.user.reset.success,
        resetLoading: state.user.reset.loading,
        resetError: state.user.reset.error,
        undeleteSuccess: state.user.undelete.success,
        undeleteLoading: state.user.undelete.loading,
        undeleteError: state.user.undelete.error,
        payeeSuccess: state.user.payee.success,
        payeeLoading: state.user.payee.loading,
        payeeError: state.user.payee.error,
        adminSuccess: state.user.admin.success,
        adminLoading: state.user.admin.loading,
        adminError: state.user.admin.error,

    }),
    ({ resetUserPassword, undeleteUser, updateUser, payeeUser, adminUser })
)(injectIntl(EditUser));



// WEBPACK FOOTER //
// ./src/views/EditUser/EditUser.js